import React from 'react';
import DevComponent from "./dev-component";
import {connect} from "react-redux";




const DevContainer = props => {

  return <DevComponent {...props} />
};


const mapStateToProps = state => ({
  filtersToSend: state.filters.filtersToSend
});

const mapDispatchToProps = dispatch => ({

});


export default connect(mapStateToProps, mapDispatchToProps)(DevContainer)


// WEBPACK FOOTER //
// ./src/modules/dev/dev-container.js